import type { ProductJournalEntry } from "../../../api/WarehouseApi";
import type { IDate } from "../../../types/date";
import { getShortProductJournalActionLabel } from "../../shared/use-cases/journal-action-presentation";

export interface ProductHistoryItem {
  id: string;
  title: string;
  subtitle: string;
  actorType: "user" | "system";
  actorLabel: string;
}

function formatHistoryDate(date: IDate | null): string {
  if (!date) {
    return "дата неизвестна";
  }

  const day = String(date.day).padStart(2, "0");
  const month = String(date.month).padStart(2, "0");
  const year = String(date.year);
  const hour = String(date.hour).padStart(2, "0");
  const minute = String(date.minute).padStart(2, "0");

  return `${day}.${month}.${year} ${hour}:${minute}`;
}

export function mapProductHistoryItems(
  history: ProductJournalEntry[],
): ProductHistoryItem[] {
  return history.map((entry) => ({
    id: entry.id,
    title: `${getShortProductJournalActionLabel(entry.action)} · ${entry.value}`,
    subtitle: `${formatHistoryDate(entry.date)} · коробка ${entry.fromTo}`,
    actorType: entry.actorType,
    actorLabel: entry.actorLabel,
  }));
}
